import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { InputComponent } from '@bcef/ia-components/input';
import { ListboxModule } from '@bcef/ia-components/listbox';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { IconsModule } from '@bcef/ia-ng-icons';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskConfig, NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Observable } from 'rxjs';

import { InheritanceInformationFormGroup } from '@features/succession/forms';
import { ListBoxItem } from '@features/succession/models';
import { SuccessionFacade } from '@features/succession/succession.facade';

import { InheritanceInformationFacade } from '../inheritance-information.facade';

@Component({
  selector: 'ia-succession-heir-information-form',
  templateUrl: './heir-information-form.component.html',
  imports: [
    AsyncPipe,
    IconsModule,
    InputComponent,
    ListboxModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    TranslateModule,
    RadioButtonModule,
  ],
  standalone: true,
  providers: [provideNgxMask()],
})
export class HeirInformationFormComponent {
  private readonly inheritanceFacade = inject(InheritanceInformationFacade);

  private readonly successionFacade = inject(SuccessionFacade);

  public requiredValidator: ValidatorFn = Validators.required;

  protected readonly listBoxItemValue = this.successionFacade.listBoxItemValue;

  public genders$: Observable<ListBoxItem[]> = this.inheritanceFacade.genders$;

  public countries$: Observable<ListBoxItem[]> = this.inheritanceFacade.countries$;

  public numbersAndSpecialCharactersNotAllowed: NgxMaskConfig['patterns'] = {
    A: { pattern: new RegExp('[^0-9:\'";()&<>*^\x00|]') },
  };

  public specialCharactersNotAllowed: NgxMaskConfig['patterns'] = {
    A: { pattern: new RegExp('[^:\'";()&<>*^\x00|]') },
  };

  @Input() public title = '';

  @Input() public formGroup!: FormGroup<InheritanceInformationFormGroup>;

  @Input() public removable = false;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();

  protected listBoxOverlayConfig: OverlayConfig = {
    scrollStrategy: inject(Overlay).scrollStrategies.close(),
  };

  public onRemove(): void {
    this.remove.emit();
  }
}
